<div class="card" *ngIf="isAdministrative">
  <div class="card-header">
    <h1 class="h4 text-primary mb-1">Configuración ruta de facturación</h1>
    <small class="text-muted">
      Asigna para cada bodega <strong>administrativa</strong> sus bodegas <em>fiscales</em> destino:
      <code>Factura</code> y <code>CF/Efectivo</code>.
    </small>
  </div>

  <div class="card-body">
    <div class="table-responsive">
      <table class="table table-bordered table-hover align-middle">
        <thead class="table-light">
          <tr>
            <th class="text-center">Código</th>

            <th>Nombre bodega administrativa</th>

            <th class="text-center">
              Fiscal (Factura)
            </th>

            <th class="text-center">
              Fiscal (CF/Efectivo)
            </th>

            <th class="text-center">
              Bodega auxiliar
            </th>

            <th class="text-center">
              Límite auxiliar
            </th>

            <th class="text-center">
              % (Fiscal CF/Efectivo)
            </th>

            <th
              class="text-center"
              style="width: 1%;">
              Acciones
            </th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let admin of warehousesAdministrative; let i = index">
            <td class="text-center">{{ admin.code }}</td>
            <td>{{ admin.name }}</td>

            <!-- Fiscal para FACTURA -->
            <td>
              <select class="form-select" [(ngModel)]="admin.invoiceWarehouseId" name="invoice_{{i}}"
                (change)="onSelectChanged(admin, 'invoice')">
                <option [ngValue]="null">-- Seleccionar --</option>

                <option *ngFor="let f of warehousesFiscales" [ngValue]="f.id" [disabled]="
                          (admin.cfWarehouseId === f.id) ||
                          isUsedGlobally('invoice', f.id, i)
                        ">
                  {{ f.name }} ({{ f.code }}) — {{ f.companyName }}
                </option>
              </select>
            </td>
            <!-- Fiscal para CF / EFECTIVO -->
            <td>
              <select class="form-select" [(ngModel)]="admin.cfWarehouseId" name="cf_{{i}}"
                (change)="onSelectChanged(admin, 'cf')">
                <option [ngValue]="null">-- Seleccionar --</option>

                <option *ngFor="let f of warehousesFiscales" [ngValue]="f.id" [disabled]="
                          (admin.invoiceWarehouseId === f.id) ||
                          isUsedGlobally('cf', f.id, i)
                        ">
                  {{ f.name }} ({{ f.code }}) — {{ f.companyName }}
                </option>
              </select>
            </td>
            <!-- Bodega AUXILIAR -->
            <td>
              <select
                class="form-select"
                [(ngModel)]="admin.auxiliarWarehouseId"
                name="auxiliar_{{i}}">

                <option [ngValue]="null">
                  -- Seleccionar --
                </option>

                <option
                  *ngFor="let f of warehousesFiscales"
                  [ngValue]="f.id"
                  [disabled]="
                    admin.invoiceWarehouseId === f.id ||
                    admin.cfWarehouseId === f.id
                  ">

                  {{ f.name }} ({{ f.code }}) — {{ f.companyName }}

                </option>

              </select>
            </td>

            <!-- Límite AUXILIAR -->
            <td>
              <div class="input-group">

                <input
                  type="number"
                  class="form-control text-end"
                  [(ngModel)]="admin.auxiliarLimit"
                  name="auxiliarLimit_{{i}}"
                  min="0"
                  step="0.01"
                  placeholder="0.00"
                  (input)="admin.auxiliarLimit = admin.auxiliarLimit < 0 ? 0 : admin.auxiliarLimit"
                />

              </div>
            </td>

            <td>
              <div class="input-group">
                <input type="number" class="form-control text-end" [(ngModel)]="admin.percentageTwo"
                  name="percentageTwo_{{i}}" min="0" step="0.01" placeholder="0.00"
                  (input)="admin.percentageTwo = admin.percentageTwo < 0 ? 0 : admin.percentageTwo" />
                <span class="input-group-text">%</span>
              </div>
            </td>

            <!-- Estado / validaciones rápidas -->
            <!-- <td class="text-center">
              <span *ngIf="admin.invoiceWarehouseId && admin.cfWarehouseId && admin.invoiceWarehouseId !== admin.cfWarehouseId"
                    class="badge bg-success">OK</span>

              <span *ngIf="(admin.invoiceWarehouseId && admin.cfWarehouseId) && (admin.invoiceWarehouseId === admin.cfWarehouseId)"
                    class="badge bg-danger">No repetir fiscal en la fila</span>

              <span *ngIf="!admin.invoiceWarehouseId || !admin.cfWarehouseId"
                    class="badge bg-secondary">Incompleto</span>
            </td> -->

            <!-- Guardar individual -->
            <td class="text-center">
              <button class="btn btn-sm btn-primary" (click)="saveRow(admin)">
                <i class="fa fa-save me-1"></i>Guardar
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Guardar todo -->
    <div class="mt-3 d-flex gap-2 justify-content-end">
      <button class="btn btn-outline-secondary" (click)="reloadData()">
        <i class="fa fa-rotate me-2"></i>Recargar
      </button>
    </div>
  </div>
</div>

<div class="card" *ngIf="!isAdministrative">
  <div class="card-header">
    <h1 class="h4 text-danger mb-0">Configuración ruta de facturación</h1>
  </div>
  <div class="card-body">
    <div class="alert alert-warning">
      Debes ingresar a una empresa <strong>administrativa</strong> para configurar la ruta.
    </div>
  </div>
</div>